import { useState } from 'react'

import { stopPropagation } from '../../../../utils/events'
import { useWidgetExpandedState } from '../useWidgetExpandedState'

export function useWidgetStates({
  initiallyExpanded = true,
  isCollapsible = true,
  isExpanded: isExpandedProp,
  onToggleExpanded,
}) {
  const isExpandedControlled = isExpandedProp != null

  const [isEditMode, setEditMode] = useState(false)
  const {
    handleExpandedChangeByUser,
    isExpanded: isExpandedState,
    registerExpandButton,
  } = useWidgetExpandedState({
    initiallyExpanded,
    isFollowingWidgetsExpand: isCollapsible && !isExpandedControlled,
  })

  const isExpanded = isExpandedControlled ? isExpandedProp : isExpandedState

  function handleToggleExpanded(event) {
    stopPropagation(event)

    if (!isExpandedControlled) {
      handleExpandedChangeByUser(!isExpanded)
    }

    onToggleExpanded?.(!isExpanded)
  }

  function handleEnableEditMode() {
    setEditMode(true)
  }

  function handleDisableEditMode() {
    setEditMode(false)
  }

  return {
    handleDisableEditMode,
    handleEnableEditMode,
    handleToggleExpanded,
    isEditMode,
    isExpanded,
    registerExpandButton,
  }
}
